/**
 * MELP Mail Typography System
 * Based on Google Material Design
 * Primary Font: Google Sans
 * Fallback: Roboto
 */

export const typography = {
  fontFamily: '"Google Sans", "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: '"Google Sans", "Roboto", sans-serif',
    fontWeight: 500,
    fontSize: '2.5rem',
    lineHeight: 1.2,
    letterSpacing: '-0.01562em',
  },
  h2: {
    fontFamily: '"Google Sans", "Roboto", sans-serif',
    fontWeight: 500,
    fontSize: '2rem',
    lineHeight: 1.3,
    letterSpacing: '-0.00833em',
  },
  h3: {
    fontFamily: '"Google Sans", "Roboto", sans-serif',
    fontWeight: 500,
    fontSize: '1.75rem',
    lineHeight: 1.4,
    letterSpacing: '0em',
  },
  h4: {
    fontFamily: '"Google Sans", "Roboto", sans-serif',
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.4,
    letterSpacing: '0.00735em',
  },
  h5: {
    fontFamily: '"Google Sans", "Roboto", sans-serif',
    fontWeight: 500,
    fontSize: '1.25rem',
    lineHeight: 1.5,
    letterSpacing: '0em',
  },
  h6: {
    fontFamily: '"Google Sans", "Roboto", sans-serif',
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: 1.6,
    letterSpacing: '0.0075em',
  },
  subtitle1: {
    fontFamily: '"Google Sans", "Roboto", sans-serif',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.75,
    letterSpacing: '0.00938em',
  },
  subtitle2: {
    fontFamily: '"Google Sans", "Roboto", sans-serif',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.57,
    letterSpacing: '0.00714em',
  },
  body1: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
  },
  body2: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.43,
    letterSpacing: '0.01071em',
  },
  button: {
    fontFamily: '"Google Sans", "Roboto", sans-serif',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.75,
    letterSpacing: '0.02857em',
    textTransform: 'none' as const,
  },
  caption: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.66,
    letterSpacing: '0.03333em',
  },
  overline: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 2.66,
    letterSpacing: '0.08333em',
    textTransform: 'uppercase' as const,
  },
} as const;

export type Typography = typeof typography;
